module.exports = __webpack_public_path__ + "static/media/1-6.2ccc484f.jpg";